const DISABLED_SUMMARY = Object.freeze({ loggingDisabled: true });

export const isDataFlowLoggingEnabled = () => false;

export const summarizeToken = () => DISABLED_SUMMARY;

export const summarizeUser = () => DISABLED_SUMMARY;

export const summarizeCollection = () => DISABLED_SUMMARY;

export const summarizeCommunity = () => DISABLED_SUMMARY;

export const dataFlowLog = () => {};
